import { defineStore } from 'pinia';

export const useGlobalStore = defineStore('global', {
    state: () => ({
        announcement: null,
        breadcrumbs: [],
        hideBanner: false,
        pageContent: {},
        pageModel: 'page'
    }),
    actions: {
        init(data) {
            if (!data) return;
        },
        setBreadcrumb(data) {
            this.breadcrumbs = data;
        },
        hideBanner(data) {
            this.hideBanner = true
        }
    },
});
